// extracted by mini-css-extract-plugin
export var aiStarIcon = "_m1-2";
export var container = "_m1-4";
export var dismissButton = "_m1-3";
export var hasPaddingBottom = "_m1-6";
export var last = "_m1-e";
export var scrollbarThumb = "_m1-c";
export var scrollbarTrack = "_m1-b";
export var selected = "_m1-9";
export var spin = "_m1-1";
export var spinning = "_m1-0";
export var suggestionItem = "_m1-d";
export var suggestionsPanel = "_m1-5";
export var tonePill = "_m1-8";
export var tonesContainer = "_m1-7";
export var unselected = "_m1-a";